import styled from '@emotion/styled'
import { Accordion, type AccordionProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface StyledAccordionProps extends AccordionProps {}

const StyledAccordion = styled(
  Accordion,
  {},
)<StyledAccordionProps>(({}) => {
  const theme = useTheme()
  return {
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    boxShadow: 'none',
    borderRadius: '4px',
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '0',
    },
  }
})

export default StyledAccordion
